// Global text normalization for mojibake/encoding glitches seen in some responses.

const STRING_FIXUPS = [
  [/\uFFFD/g, ''],
  [/\u00C3\u00A9/g, '\u00E9'],
  [/\u00C3\u00A8/g, '\u00E8'],
  [/\u00C3\u00AA/g, '\u00EA'],
  [/\u00C3\u00A0/g, '\u00E0'],
  [/\u00C3\u00A7/g, '\u00E7'],
  [/\u00C3\u00B4/g, '\u00F4'],
  [/\u00C3\u00BB/g, '\u00FB'],
  [/\u00C3\u00AE/g, '\u00EE'],
  [/\u00C3\u00AF/g, '\u00EF'],
  [/\u00C3\u00A2/g, '\u00E2'],
  [/\u00C5\u2019/g, '\u2019'],
  [/\u00E2\u20AC\u2122/g, '\u2019'],
  [/\u00E2\u20AC\u201C/g, '\u2013'],
  [/\u00E2\u20AC\u201D/g, '\u2014'],
  [/\u00E2\u20AC\u0153/g, '\u201C'],
  [/\u00E2\u20AC\u009D/g, '\u201D'],
  [/\u00C2\u00A0/g, ' '],
  [/valid\?\?/gi, 'valid\u00E9'],
  [/re\?\?u/gi, 're\u00E7u'],
  [/d\?\?compte/gi, 'd\u00E9compte'],
  [/^\?{3,}\s*Vote/gi, 'Vote'],
  [/\?{2,}/g, '?'],
];

export function repairTextEncoding(value) {
  if (typeof value !== 'string') {
    return value;
  }

  let result = value;
  for (const [pattern, replacement] of STRING_FIXUPS) {
    result = result.replace(pattern, replacement);
  }
  return result;
}

export function normalizeTextPayload(payload) {
  if (typeof payload === 'string') {
    return repairTextEncoding(payload);
  }

  if (Array.isArray(payload)) {
    return payload.map((entry) => normalizeTextPayload(entry));
  }

  if (payload && typeof payload === 'object') {
    const normalized = {};
    for (const [key, value] of Object.entries(payload)) {
      normalized[key] = normalizeTextPayload(value);
    }
    return normalized;
  }

  return payload;
}
